module.exports = __webpack_public_path__ + "static/media/pink_tag_icon.794ec117.svg";